// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__14syf","Button":"Loader_Button__2xkFA","loader":"Loader_loader__1I38t","load1":"Loader_load1__2j7ra"};